import useGetContragentTypes from './useGetContragentTypes';
import GettingStarted from '../forms/GettingStarted/GettingStarted.tsx';
import { GeneralInfoLegalResident } from '../forms/GeneralInfo/GeneralInfoLegalResident.tsx';
import { GeneralInfoAssetManager } from '../forms/GeneralInfo/GeneralInfoAssetManager.tsx';
import { RelatedCompanies } from '../forms/RelatedCompanies/RelatedCompanies.tsx';
import { ManagementStructure } from '../forms/ManagementStructure/ManagementStructure.tsx';
import { ManagersAndRepresentatives } from '../forms/ManagersAndRepresentatives/ManagersAndRepresentatives.tsx';
import OwnershipStructure from '../forms/OwnershipStructure/OwnershipStructure';
import AdditionalInformation from '../forms/AdditionalInformation/AdditionalInformation';
import FinancialCondition from '../forms/FinancialCondition/FinancialCondition.tsx';
import BusinessRelations from '../forms/BusinessRelations/BusinessRelations.tsx';
import Documents from '../forms/Documents/Documents';
import { GeneralInfoSoleTrader } from '../forms/GeneralInfo/GeneralInfoSoleTrader.tsx';
import useGetUserRole from '../../../hooks/useGetUserRole.ts';
import { useFeatureFlags } from '~/helpers/FeatureFlagsContext.js';
import { ComplexOwnershipStructure } from '../forms/OwnershipStructure/ComplexOwnershipStructure.tsx';
import { useSelector } from 'react-redux';
import { TaxResidencyAdditionalInformation } from '~/modules/identification/forms/TaxResidencyAdditionalInformation/TaxResidencyAdditionalInformation.tsx';
import { selectIsReidentification } from '~/store/identification-form/selectors.ts';

export const useGetStepsComponents = (nextStepHandler: () => void) => {
  const { isLegalResident, isSoleTrader } = useGetContragentTypes();
  const { isAssetManager } = useGetUserRole();
  const { isOwnershipStructureTreeEnabled, isOwnershipStructureTreeReIdentificationEnabled, isAdditionalInformationAboutTaxResidencyEnabled } =
    useFeatureFlags();
  const isReidentification = useSelector(selectIsReidentification);

  return {
    gettingStarted: <GettingStarted onNextStep={nextStepHandler} />,
    generalInfo: (
      <>
        {isSoleTrader && <GeneralInfoSoleTrader onNextStep={nextStepHandler} />}
        {isLegalResident && <GeneralInfoLegalResident onNextStep={nextStepHandler} />}
        {isAssetManager && <GeneralInfoAssetManager onNextStep={nextStepHandler} />}
      </>
    ),
    relatedCompanies: <RelatedCompanies onNextStep={nextStepHandler} />,
    managementStructure: <ManagementStructure onNextStep={nextStepHandler} />,
    managersAndRepresentatives: <ManagersAndRepresentatives onNextStep={nextStepHandler} />,
    ownershipStructure: isReidentification ? (
      isOwnershipStructureTreeReIdentificationEnabled ? (
        <ComplexOwnershipStructure onNextStep={nextStepHandler} />
      ) : (
        <OwnershipStructure onNextStep={nextStepHandler} />
      )
    ) : isOwnershipStructureTreeEnabled ? (
      <ComplexOwnershipStructure onNextStep={nextStepHandler} />
    ) : (
      <OwnershipStructure onNextStep={nextStepHandler} />
    ),
    additionalInformation: <AdditionalInformation onNextStep={nextStepHandler} />,
    taxResidencyAdditionalInformation: isAdditionalInformationAboutTaxResidencyEnabled && (
      <TaxResidencyAdditionalInformation onNextStep={nextStepHandler} />
    ),
    financialState: <FinancialCondition onNextStep={nextStepHandler} />,
    purposeOfBusinessRelations: <BusinessRelations onNextStep={nextStepHandler} />,
    documents: <Documents />,
  };
};
